export default __webpack_public_path__ + "static/media/Login Page Hero Image.7bbc58d3.jpg";